@if (awaitingResponse) {
  <div class="loading-wrapper">
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  </div>
}

@if (!awaitingResponse) {
  <div class="wrapper" role="main">
    <img
      class="success-image"
      src="https://firebasestorage.googleapis.com/v0/b/wemaron-vouchers.appspot.com/o/img%2Femails%2Fheaders%2FImageEmail2.png?alt=media&token=69d41c69-93e8-4eea-895f-ccdb1246a286"
      alt="success image"
    />
    <div class="title-position">
      <div role="heading" aria-level="1">
        <div class="title">{{ titleAbove }}</div>
        <div class="title">{{ titleBelow }}</div>
      </div>
      @if (order.status === 'done' || order.status === 'paid') {
        <div class="order-confirmation">
          {{ 'buy.succeed.order-confirmation' | translate }}
        </div>
      }
    </div>
    @if (order.status === 'done' || order.status === 'paid') {
      <div class="your-order" role="heading" aria-level="2">
        {{ 'buy.succeed.your-order' | translate }}
      </div>
    }
    <mat-divider></mat-divider>
    @if (order.status === 'done' || order.status === 'paid') {
      <div class="order-table">
        <div class="order-table-row">
          <div class="order-table-column">Artikel</div>
          <div class="order-table-column">Aantal</div>
          <div class="order-table-column">Prijs</div>
        </div>
        @for (dataObject of data; track dataObject) {
          <div class="order-table-row">
            <div class="order-table-column">{{ dataObject.article }}</div>
            <div class="order-table-column">{{ dataObject.amount }}</div>
            <div class="order-table-column">{{ dataObject.price }}</div>
          </div>
        }
      </div>
    }
    @if (order.downloadUrl && !awaitingResponse) {
      <button
        class="button-positioning spinner-button secondary-color"
        mat-flat-button
        class="spinner-button"
        (click)="openWindow(order.downloadUrl)"
      >
        {{ 'buy.button.download' | translate }}
        <!-- <mat-spinner
          diameter="20"
          color="spinner"
          *ngIf="awaitingResponse"
        ></mat-spinner> -->
      </button>
    }
    @if (!order.downloadUrl && redirectUrl && !awaitingResponse) {
      <button class="button-positioning" mat-flat-button (click)="openWindow(redirectUrl)">
        {{ 'buy.button.close' | translate }}
      </button>
    }
  </div>
}
